export default __webpack_public_path__ + "static/media/5.cb5cedd0.svg";